// ✅ Apropos.jsx — Page d'à propos responsive
import React from "react";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import FooterOutils from "../components/Footer";

export default function Apropos() {
  return (
    <>
      <div>
        <MenuNav />
        <MobileMenu />
        <div className="container py-5">
          <div className="text-center mb-5">
            <h1 className="fw-bold">Qui sommes-nous ?</h1>
            <p className="lead text-muted">
              Une plateforme d'outils agricoles au service des producteurs.
            </p>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-md-6">
              <img
                src="/images/agriculture-team.jpg"
                alt="Notre équipe"
                className="img-fluid rounded shadow-sm"
              />
            </div>
            <div className="col-md-6">
              <h3 className="fw-bold">Notre mission</h3>
              <p>
                Offrir une gamme variée d'outils agricoles de qualité, accessibles aux
                agriculteurs du pays et de la sous-région, en facilitant la mise en relation
                avec les bons fournisseurs.
              </p>
              <p>
                Nous croyons que l'accès à un bon matériel est essentiel pour une agriculture
                moderne, efficace et rentable.
              </p>
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-md-6 order-md-2">
              <img
                src="/images/outils-agricoles.jpg"
                alt="Outils agricoles"
                className="img-fluid rounded shadow-sm"
              />
            </div>
            <div className="col-md-6">
              <h3 className="fw-bold">Nos valeurs</h3>
              <ul>
                <li className="mb-2">Accessibilité</li>
                <li className="mb-2">Fiabilité</li>
                <li className="mb-2">Innovation</li>
                <li className="mb-2">Soutien aux producteurs</li>
              </ul>
            </div>
          </div>

          <div className="bg-light rounded p-4 text-center">
            <h4>Un projet au service du développement agricole</h4>
            <p>
              Que vous soyez un agriculteur, un distributeur ou un partenaire
              institutionnel, rejoignez-nous dans cette mission.
            </p>
            <a href="/contact" className="btn btn-success mt-3">
              Contactez-nous
            </a>
          </div>
        </div>
      </div>
      <FooterOutils />
    </>
  );
}
